/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShopifyDimensionMetafieldMapping } from "./ShopifyDimensionMetafieldMapping";
import {
  ShopifyDimensionMetafieldMappingFromJSON,
  ShopifyDimensionMetafieldMappingFromJSONTyped,
  ShopifyDimensionMetafieldMappingToJSON,
  ShopifyDimensionMetafieldMappingToJSONTyped,
} from "./ShopifyDimensionMetafieldMapping";
import type { ShopifyMetafieldKeySummary } from "./ShopifyMetafieldKeySummary";
import {
  ShopifyMetafieldKeySummaryFromJSON,
  ShopifyMetafieldKeySummaryFromJSONTyped,
  ShopifyMetafieldKeySummaryToJSON,
  ShopifyMetafieldKeySummaryToJSONTyped,
} from "./ShopifyMetafieldKeySummary";

/**
 *
 * @export
 * @interface ShopifyMetafieldDiscovery
 */
export interface ShopifyMetafieldDiscovery {
  /**
   *
   * @type {Array<ShopifyMetafieldKeySummary>}
   * @memberof ShopifyMetafieldDiscovery
   */
  found: Array<ShopifyMetafieldKeySummary>;
  /**
   *
   * @type {ShopifyDimensionMetafieldMapping}
   * @memberof ShopifyMetafieldDiscovery
   */
  suggestedMapping?: ShopifyDimensionMetafieldMapping | null;
}

/**
 * Check if a given object implements the ShopifyMetafieldDiscovery interface.
 */
export function instanceOfShopifyMetafieldDiscovery(
  value: object,
): value is ShopifyMetafieldDiscovery {
  if (!("found" in value) || value["found"] === undefined) return false;
  return true;
}

export function ShopifyMetafieldDiscoveryFromJSON(
  json: any,
): ShopifyMetafieldDiscovery {
  return ShopifyMetafieldDiscoveryFromJSONTyped(json, false);
}

export function ShopifyMetafieldDiscoveryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyMetafieldDiscovery {
  if (json == null) {
    return json;
  }
  return {
    found: (json["found"] as Array<any>).map(
      ShopifyMetafieldKeySummaryFromJSON,
    ),
    suggestedMapping:
      json["suggestedMapping"] == null
        ? undefined
        : ShopifyDimensionMetafieldMappingFromJSON(json["suggestedMapping"]),
  };
}

export function ShopifyMetafieldDiscoveryToJSON(
  json: any,
): ShopifyMetafieldDiscovery {
  return ShopifyMetafieldDiscoveryToJSONTyped(json, false);
}

export function ShopifyMetafieldDiscoveryToJSONTyped(
  value?: ShopifyMetafieldDiscovery | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    found: (value["found"] as Array<any>).map(ShopifyMetafieldKeySummaryToJSON),
    suggestedMapping: ShopifyDimensionMetafieldMappingToJSON(
      value["suggestedMapping"],
    ),
  };
}
